import { render, staticRenderFns } from "./AlbaraOrdreEixidaList.vue?vue&type=template&id=75d53a02&scoped=true"
import script from "./AlbaraOrdreEixidaList.vue?vue&type=script&lang=js"
export * from "./AlbaraOrdreEixidaList.vue?vue&type=script&lang=js"
import style0 from "./AlbaraOrdreEixidaList.vue?vue&type=style&index=0&id=75d53a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d53a02",
  null
  
)

export default component.exports